import { render, staticRenderFns } from "./PromotionExport.vue?vue&type=template&id=2e28cdc0"
import script from "./PromotionExport.vue?vue&type=script&lang=js"
export * from "./PromotionExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports